<template>
    <div class="form-group">
        <label :for="getId" class="label">
            {{ label }}
            {{ required ? '*' : '' }}
        </label>

        <input 
            v-if="!mask"
            @input="handleInput"
            :value="value"
            :name="name"
            :type="type"
            :required="required"
            :disabled="disabled"
            :id="getId"
            :placeholder="placeholder"
            class="form-control input"
            v-bind:class="{ 'is-invalid': error }"
            :max="max"
            :min="min"
        />

        <the-mask 
            v-else
            @input="handleMaskInput"
            :name="name"
            :type="type"
            :required="required"
            :disabled="disabled"
            :id="getId"
            :placeholder="placeholder"
            :value="value"
            class="form-control input"
            v-bind:class="{ 'is-invalid': error }"
            :mask="mask"
            :max="max"
            :min="min"
        />
        
        <small
            v-if="helperText"
            class="form-text"
            v-bind:class="{ 'invalid-feedback': error, 'text-muted': !error }"
        >
            {{ helperText }}
        </small>
    </div>
</template>

<script>

import {TheMask} from 'vue-the-mask'

export default {
    components: { TheMask },
    props: {
        id: {
            type: String,
            required: false,
        },
        label: {
            type: String,
            required: false,
        },
        value: {
            required: true,
        },
        name: {
            type: String,
            required: false,
        },
        error: {
            type: Boolean,
            required: false,
            default: false
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
        helperText: {
            type: String,
            required: false,
            default: null
        },
        placeholder: {
            type: String,
            required: false,
        },
        type: {
            type: String,
            required: false,
            default: 'text'
        },
        required: {
            type: Boolean,
            required: false,
            default: false
        },
        mask: {
            required: false,
            default: null
        },
        max: {
            type: [String, Number],
            required: false,
            default: null
        },
        min: {
            type: [String, Number],
            required: false,
            default: null
        },
    },
    data(){
        return {
            content: this.value,
            randomId: null,
        };
    },
    computed: {
        getId () {
            return this.id ? this.id : this.randomId
        }
    },
    methods: {
        handleInput(e) {
            let newValue = e.target.value
            if (this.type === 'number') {
                newValue = parseFloat(newValue)
            }
            this.$emit('input', newValue)
            this.$emit('change', newValue)
        },
        handleMaskInput(value) {
            let newValue = value
            if (this.type === 'number') {
                newValue = parseFloat(value)
            }
            this.$emit('input', newValue)
            this.$emit('change', newValue)
        },
    },
    mounted() {
        this.randomId = Math.random().toString(36).substr(2, 9)
    }
}
</script>

<style scoped lang="scss">
</style>
